import { ApiProfile, apiRoute } from 'services/rest-util';

// dummy class to make it easy to use baseapi class
export module ServiceReportModels {
  export class ServiceReports {
    public static ApiUrl: string = 'api/service-reports';
  }
}

export class ServiceStationWeekReport {
  public ServiceStationId: number;
  public ServiceStationName: string;

  public Weeks: ServiceWeek[];
}

export class ServiceStationServiceTaskSummary {
  public ServiceStationId: number;
  public ServiceStationName: string;

  public NetTypeId?: number;
  public NetTypeName?: string;

  public IsSpecialProduct: boolean;
  public SpecialProductTypeId?: number;
  public SpecialProductTypeName: string;

  public PriceConfigurationMissing: boolean;

  public NetsWashing: number;
  public WashingEstimatePrice: number;

  public WasteEstimateKg: number;
  public WasteEstimatePrice: number;

  public NetsRepair: number;
  public RepairEstimateHours: number;
  public RepairEstimatePrice: number;
  public RepairActualHours: number;

  public NetsAntifouling: number;
  public AntifoulingEstimateLiters: number;
  public AntifoulingEstimatePrice: number;
  public AntifoulingActualLiters: number;
  public AntifoulingActualPrice: number;
  public AntifoulingMissingPrices: string;

  public TotalEstimatePrice: number;
}

export class ServiceWeek {
  public FromDate: number;
  public ToDate: number;
  public SumTotal: number;
  public SumEstimateRepair: number;
  public SumEstimateWashing: number;
  public SumEstimateWaste: number;
  public SumEstimateAntifouling: number;
  public Summaries: ServiceStationServiceTaskSummary[];
}

export class ServiceReportDetail {
  public NetId: number;
  public ServiceId: number;
  public NetIdentifier: string;
  public CustomerName: string;
  public IsSpecialProduct: boolean;
  public NetTypeId?: number;
  public NetTypeName: string;
  public SpecialProductTypeId?: number;
  public SpecialProductTypeName: string;
  public WashedDate?: Date;
  public InvoicedWashing?: Date;
  public RepairedDate?: Date;
  public InvoicedRepair?: Date;
  public RepairActualHours?: number;
  public AntifouledDate?: Date;
  public InvoicedAntifouling?: Date;
  public ServiceStatusName: string;
}

export class ServiceStatisticsData {
  public FromDate: Date;
  public ToDate: Date;
  public ServiceStationId: number;
  public ServiceStationName: string;
  public ReceivedInPeriod: number;
  public WashedInPeriod: number;
  public TestedInPeriod: number;
  public RepairedInPeriod: number;
  public AntifouledInPeriod: number;
  public DeliveredInPeriod: number;
  public HoursReparationInPeriod: number;
  public ImpregnationLitersInPeriod: number;
}

export class ServiceStatistics {
  public Data: Array<ServiceStatisticsData>;
  public SummaryData: ServiceStatisticsData;
}
